<template>
    <button type="button" class="btn btn-lg btn-outline-regular btn-bi" data-bs-toast="toast_fav"
            @click.prevent="inFavourites ? deleteFromFavourites(id) : addToFavourites(id)"
    >
        <i v-if="this.inFavourites" class="bi bi-suit-heart-fill"></i>
        <i v-else class="bi bi-suit-heart"></i>
    </button>
</template>

<script>
    export default {
        props: ['id'],

        computed: {
            inFavourites() {
                return this.$store.state.favourites.items.find(x => x.id == this.id);
            }
        },

        methods: {
            addToFavourites() {
                this.$store.dispatch('favourites/addToFavourites', this.id)
            },

            deleteFromFavourites() {
                this.$store.dispatch('favourites/deleteFromFavourites', this.id)
            }
        },
    }
</script>
